<template>
    <div>
        <!-- <el-form :model="form" label-width="120px" label-position="left" style="width:350px;margin-left:50px;margin-top:50px;">
            <el-form-item label="我的头像" v-show="reg_type=='wechat'">
                <div style="height:40px;">
                    <el-avatar :src="form.avatar_src" :fit="fit">
                        <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                    </el-avatar>
                </div>
            </el-form-item>
            <el-form-item label="我的昵称">
                <el-input v-model="form.nickname" v-if="form.status=='modify'"></el-input>
                <span v-else>{{ form.nickname }}</span>
            </el-form-item>
            <el-form-item label="我的邮箱" v-show="reg_type=='wechat'">
                <el-input v-model="form.email" v-if="form.status=='modify'"></el-input>
                <span v-else>{{ form.email }}</span>
            </el-form-item>
            <el-form-item label="绑定手机">
                <el-input v-model="form.tel_num" v-if="form.status=='modify'"></el-input>
                <span v-else>{{ form.tel_num }}</span>
            </el-form-item>
            <el-form-item label="我的积分">
                <span>{{ form.score }}分</span>
                <el-button type="primary" size="mini" style="margin-left:10px;" @click="getScoreDetails">查看明细</el-button>
            </el-form-item>
            <div style="padding-right:100px; margin-top:40px;">
                <el-button type="warning" @click="modify_user_data">修改</el-button>
                <el-button type="primary" @click="save_user_data">保存</el-button>
            </div>
        </el-form> -->
        <div style="width:900px;">           
            <div class="profile-content">
                <div class="avatar-section">
                    <div class="avatar-container">
                        <img :src="form.photo" alt="用户照片" id="avatar-img">
                    </div>
                    
                    <div class="avatar-actions">
                        <button class="btn btn-primary" @click="openFileDialog">
                            <i class="fas fa-upload"></i> 上传新照片
                        </button>
                        <p class="requirements">支持格式: JPG, PNG, JPEG, GIF | 最大5MB</p>
                        <!-- <button class="btn btn-outline" v-if="user.avatar !== defaultAvatar" @click="resetAvatar">
                            <i class="fas fa-redo"></i> 恢复默认头像
                        </button> -->
                    </div>
                                        
                    <input type="file" id="file-input" class="file-input" accept=".jpg,.jpeg,.png,.gif" @change="handleFileSelect">
                </div>
                
                <div class="info-section">
                    <div class="form-row">
                        <div class="form-group">
                            <label for="name">我的姓名</label>
                            <input v-model="form.name" placeholder="请输入姓名">
                        </div>
                        
                        <div class="form-group">
                            <label for="email">我的邮箱</label>
                            <input v-model="form.email" placeholder="请输入邮箱地址" readonly>
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group">
                            <label for="nick_name">我的昵称</label>
                            <input v-model="form.nick_name" placeholder="请输入昵称">
                        </div>
                        
                        <div class="form-group">
                            <label for="phone">绑定手机</label>
                            <input v-model="form.tel_num" placeholder="请输入手机号码">
                        </div>
                    </div>

                    <div class="form-row" v-if="show_expert_info">
                        <div class="form-group">
                            <label for="company">履历公司</label>
                            <input v-model="form.company" placeholder="请输入履历公司名称">
                        </div>
                        
                        <div class="form-group">
                            <label for="position">我的职位</label>
                            <input v-model="form.position" placeholder="请输入职位名称">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <label for="points">我的积分</label>
                            <input v-model="form.points" readonly>
                        </div>
                        <el-button type="primary" size="mini" style="margin-right:160px;height:38.5px;margin-top:30px;" @click="getScoreDetails">查看明细</el-button>
                    </div>

                    <div class="form-row" v-if="show_expert_info">
                        <div class="form-group">
                            <label for="fields">擅长领域</label>
                            <textarea v-model="form.fields" placeholder="请介绍您的擅长领域"></textarea>
                        </div>
                    </div>

                    <div class="form-row" v-if="show_expert_info">
                        <div class="form-group">
                            <label for="industries">擅长行业</label>
                            <textarea v-model="form.industries" placeholder="请介绍您的擅长行业"></textarea>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div>
            <!-- <el-button type="warning" @click="modify_user_data">修改</el-button> -->
            <el-button type="primary" @click="save_user_data">保存</el-button>
        </div>
        <!-- 图片裁剪模态框 -->
        <div class="modal" :class="{ active: showCropper }">
            <div class="modal-content">
                <span class="close-modal" @click="showCropper = false">&times;</span>
                <h2>裁剪图片</h2>
                <p>请选择要展示的区域，裁剪结果将显示为圆形</p>
                
                <div class="crop-container">
                    <img :src="uploadedImage" id="image-to-crop" style="max-width: 100%">
                </div>
                
                <div class="crop-actions">
                    <button class="btn btn-cancel" @click="showCropper = false">取消</button>
                    <button class="btn btn-primary" @click="cropImage">确认裁剪</button>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            :fullscreen="true"
            :show-close="false"
            custom-class="fullscreen-dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <template #title>
                <div class="dialog-header">
                <span>查看积分明细</span>
                <el-button
                    class="close-btn"
                    icon="el-icon-close"
                    @click="dialogVisible = false"
                ></el-button>
                </div>
            </template>

            <!-- 弹窗内容 -->
            <div class="dialog-content">
                <div class="ql-editor" style="margin-left:50px;margin-right:50px;margin-top:10px;">
                    <el-table
                    ref="multipleTable"
                    :data="details_info"
                    row-key="id"
                    style="width:100%"
                    stripe
                    border>
                        <el-table-column type="index"></el-table-column>
                        <el-table-column prop="change_date" label="积分日期" min-width="25%"></el-table-column>
                        <el-table-column prop="change_reason" label="积分事由" min-width="45%"></el-table-column>
                        <el-table-column prop="score_change" label="积分变动" min-width="15%"></el-table-column>
                        <el-table-column prop="current_score" label="变动后积分" min-width="15%"></el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>   
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
    name: 'ImageCropper',
    created() {
        this.getUserData();
    },
    data() {
        return {
            reg_type: 'email',
            form: {},
            dialogVisible: false,
            details_info: [],
            show_expert_info: false,
            defaultAvatar: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
            uploadedImage: '',
            showCropper: false,
            cropper: null,
            showNotification: false,
        }
    },
    methods: {
        getScoreDetails() {
            getdata.getList("getGLYFScoreDetails")
            .then(resp => {
                if(resp.data.code == 200){
                    this.details_info = resp.data.data;
                    this.dialogVisible = true;
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        modify_user_data() {
            this.form.status = 'modify';
        },
        save_user_data() {
            postdata.postList("saveGLYFUserData", JSON.stringify(this.form))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: '保存成功！',
                    type: 'success',
                    })
                    this.getUserData();
                }else{
                    this.$message({
                    message: '保存失败！',
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getUserData() {
            getdata.getList("getGLYFUserData")
            .then(resp => {
                if(resp.data.code == 200){
                    this.form = resp.data.data;
                    this.reg_type = resp.data.reg_type;
                    if(!this.form.photo){
                        this.form.photo = '/img/default_avatar.png'
                    }
                    if('position' in resp.data.data){
                        this.show_expert_info = true;
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        openFileDialog() {
            document.getElementById('file-input').click();
        },
                
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            // 检查文件类型
            const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
            if (!validTypes.includes(file.type)) {
                this.showNotificationMessage('请选择JPG、PNG或GIF格式的图片！', 'error');
                return;
            }
            
            // 检查文件大小（5MB）
            if (file.size > 5 * 1024 * 1024) {
                this.showNotificationMessage('图片大小不能超过5MB！', 'error');
                return;
            }
            
            const reader = new FileReader();
            reader.onload = (e) => {
                this.uploadedImage = e.target.result;
                this.showCropper = true;
                
                this.$nextTick(() => {
                    // 初始化Cropper.js
                    const image = document.getElementById('image-to-crop');
                    if (this.cropper) {
                        this.cropper.destroy();
                    }
                    
                    this.cropper = new Cropper(image, {
                        aspectRatio: 1,
                        viewMode: 1,
                        guides: true,
                        movable: true,
                        rotatable: false,
                        scalable: false
                    });
                });
            };
            reader.readAsDataURL(file);
        },
        
        // 初始化Cropper实例
        initCropper() {
            if (this.cropper) {
                this.cropper.destroy();
            }
            
            // 在nextTick中确保DOM已更新:cite[6]
            this.$nextTick(() => {
                // const imgElement = this.$refs.imgElement;
                const image = document.getElementById('image-to-crop');
                this.cropper = new Cropper(image, {
                    aspectRatio: 1, // 设置裁剪框为1:1比例:cite[1]:cite[6]
                    viewMode: 1,    // 限制裁剪框不超过图片范围:cite[1]
                    autoCropArea: 0.8, // 初始裁剪区域占图片的80%:cite[1]
                    movable: true,  // 允许移动图片
                    zoomable: true, // 允许缩放图片
                    rotatable: true, // 允许旋转图片
                    scalable: true, // 允许缩放图片（改变长宽）:cite[1]
                    cropBoxMovable: true, // 允许移动裁剪框
                    cropBoxResizable: true, // 允许调整裁剪框大小
                    background: true, // 显示网格背景:cite[4]
                    guides: true, // 显示裁剪框的虚线:cite[1]
                    center: true, // 显示裁剪框中间的'+'指示器:cite[1]
                });
            });
        },
        
        // 裁剪图片
        cropImage() {
            console.log("cropper: ", this.cropper);
            if (!this.cropper) return;
                    
            // 获取裁剪后的canvas
            const canvas = this.cropper.getCroppedCanvas({
                width: 300,
                height: 300
            });
            
            // 转换为base64并更新头像
            this.form.photo = canvas.toDataURL('image/jpeg', 0.8);
            
            (async () => {
                try {
                    // 将canvas转换为blob对象
                    const blob = await new Promise(resolve => {
                        canvas.toBlob(resolve, 'image/jpeg', 0.8);
                    });

                    const formData = new FormData()
                    formData.append('image', blob)

                    // 调用后端上传接口
                    const { data } = await postdata.uploadFilesAuth('uploadImages', formData)
                    this.form.photo = data.url;
                    this.showCropper = false;
                    this.$message({
                    message: '上传成功！',
                    type: 'success',
                    })
                } catch (error) {
                    console.error('上传失败:', error);
                }
            })();
            
            
            // 清理
            this.cropper.destroy();
            this.cropper = null;
            document.getElementById('file-input').value = '';
            
            // this.showNotificationMessage('头像更新成功！', 'success');
        },
        
        resetAvatar() {
            this.user.photo = this.defaultAvatar;
            this.showNotificationMessage('已恢复默认头像', 'success');
        },
        
        saveUserInfo() {
            // 在实际应用中，这里应该发送API请求到Django后端
            // 模拟API请求
            this.showNotificationMessage('用户信息已保存！', 'success');
            console.log('保存的用户信息:', this.user);
        },
        
        cancelEdit() {
            // 在实际应用中，这里应该返回上一页或重置表单
            this.showNotificationMessage('已取消编辑', 'error');
        },
        
        showNotificationMessage(message, type) {
            this.notificationMessage = message;
            this.notificationClass = type;
            this.showNotification = true;
            
            // 3秒后自动隐藏通知
            setTimeout(() => {
                this.showNotification = false;
            }, 3000);
        }
    },
    // watch: {
    //     // 监听imgSrc变化，初始化Cropper
    //     imgSrc(newVal) {
    //     if (newVal) {
    //         this.$nextTick(() => {
    //         this.initCropper();
    //         });
    //     }
    //     }
    // },
    watch: {
        showCropper(newVal) {
            if (!newVal && this.cropper) {
                this.cropper.destroy();
                this.cropper = null;
            }
        },
        // uploadedImage(newVal) {
        //     if (newVal) {
        //         this.$nextTick(() => {
        //             this.initCropper();
        //         });
        //     }
        // }
    },
    beforeDestroy() {
        // 组件销毁前销毁Cropper实例:cite[1]
        if (this.cropper) {
        this.cropper.destroy();
        }
    }
}
</script>

<style scoped>
::v-deep .el-form-item__label {
    font-size: 16px;
}
::v-deep .el-form-item__content {
    font-size: 16px;
    text-align: left;
}
.profile-content {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 50px;
    margin-left: 50px;
}

.avatar-section {
    flex: 1;
    min-width: 300px;
}

.info-section {
    flex: 2;
    min-width: 300px;
}

.avatar-container {
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    border-radius: 50%;
    overflow: hidden;
    border: 4px solid #e8f4fc;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.avatar-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.avatar-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 300px;
    margin: 0 auto;
}
.form-group {
    margin-bottom: 20px;
    text-align: left;
}

label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #2c3e50;
}

input, textarea, select {
    width: 220px;
    padding: 8px;
    border: 2px solid #e1e8ed;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s;
}

input:focus, textarea:focus, select:focus {
    border-color: #3498db;
    outline: none;
}

/* 不可编辑字段的样式 */
input:read-only, textarea:read-only, select:read-only {
    background-color: #f8f9fa;
    color: #6c757d;
    cursor: not-allowed;
    border-color: #e9ecef;
}

textarea {
    width: 490px;
    /* min-height: 120px; */
    resize: vertical;
}

.form-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.form-row .form-group {
    flex: 1;
    min-width: 250px;
}
.modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    align-items: center;
    justify-content: center;
}

.modal.active {
    display: flex;
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 700px;
    padding: 25px;
    position: relative;
}

.close-modal {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 28px;
    cursor: pointer;
    color: #777;
}

.close-modal:hover {
    color: #333;
}

.crop-container {
    width: 100%;
    height: 400px;
    margin: 20px 0;
    background: #f8f9fa;
    overflow: hidden;
}

.crop-actions {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 20px;
}

.file-input {
    display: none;
}

.requirements {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-top: 5px;
}

@media (max-width: 768px) {
    .profile-content {
        flex-direction: column;
    }
    
    .avatar-container {
        width: 150px;
        height: 150px;
    }
    
    h1 {
        font-size: 2rem;
    }
}
</style>
